<template>
	<select @change='change' v-model="selected" class='form-control my-control' :class='field_class'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../constants'
	const ORGANIZATION_PROPERTY = 'get_organization_property.php'

	import {EventBus} from '../../lib/EventBus'

	export default {
		name: 'regOrganizationProperty',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			set_id: '',
			field_class: '',
			org_id: '',
			id: null
		},
		methods: {
			change () {
				EventBus.$emit(`reg-organization-property`, this.selected)
			}
		},
		mounted () {
			fetch(DB + ORGANIZATION_PROPERTY + '?org_id=' + this.$props.org_id, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.$props.id ? this.$props.id : data[0].id
					this.change()
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		},
	}
</script>


// WEBPACK FOOTER //
// organizationProperty.vue?fc7585c8